module.exports = __webpack_public_path__ + "advisor_be_grand_banner-6126e27d2b46e1d9d2e9cb3290c6cfd0.jpg";